import RealLogo from "@/components/Logo";
import { scrollToTop } from "@/lib/scrollTo";
import { useLanguage } from "@/lib/language";

export const Footer = () => {
  const { t } = useLanguage();
  return (
    <footer data-testid="footer-section" className="bg-charcoal text-cream">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-16 lg:py-20">
        <div
          onClick={scrollToTop}
          className="cursor-pointer w-fit transition-transform duration-500 hover:scale-[1.03]"
          data-testid="footer-logo"
        >
          <RealLogo className="h-24 lg:h-28 w-auto" />
        </div>
        <p className="mt-8 font-serif italic font-light text-2xl text-gold max-w-md leading-snug">
          {t.brand.tagline}
        </p>
        <p className="mt-5 text-sm text-cream/60 max-w-md leading-relaxed">
          {t.footer.description}
        </p>
        <p className="mt-4 flex items-center gap-2 text-sm text-cream/60">
          <span className="w-1.5 h-1.5 rounded-full bg-gold inline-block" />
          {t.brand.address.street}, {t.brand.address.city}
        </p>
        <div className="mt-12 pt-6 border-t border-cream/10 flex flex-col sm:flex-row justify-between gap-3 text-[11px] uppercase tracking-[0.2em] text-cream/40">
          <span>© {new Date().getFullYear()} Rezydencja REAL</span>
          <span>{t.footer.note}</span>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
